import { ProCTA } from "./super-partners/ProCTA";
import { SocialShare } from "./super-partners/SocialShare";

interface SuperPartnersProps {
  isPro: boolean;
  onShowWaitlist: () => void;
}

export const SuperPartners = ({ isPro, onShowWaitlist }: SuperPartnersProps) => {
  return (
    <div className="w-full">
      {isPro ? (
        <ProCTA onShowWaitlist={onShowWaitlist} />
      ) : (
        <SocialShare />
      )}
    </div>
  );
};